import React from 'react';
import { TranslationsFunc } from '@lang';
import { checkArrayForDuplicates } from '@root/app/utils';

type ConfigurationGroupValue = {
  isSelected: boolean;
};

type Validator = (value?: ConfigurationGroupValue[]) => string | undefined;

type ValidatorCreator = (t: TranslationsFunc, minimum?: number | null) => Validator;

type MessageCreator = (minimum: number, t: TranslationsFunc) => string;

const selectMoreOptionsMessage: MessageCreator = (minimum, t) =>
  t('treatment.pleaseSelectFollowingOptions', {
    action: <b>{t('treatment.selectAmount', { amount: minimum })}</b>,
  });

export const configurationGroupValidator: ValidatorCreator = (t, minimum) => (value) => {
  const selectedItemsCount = value?.filter((v) => v.isSelected).length;

  if (!minimum || selectedItemsCount === undefined) {
    return undefined;
  }

  return selectedItemsCount < minimum ? selectMoreOptionsMessage(minimum, t) : undefined;
};

export const validateNamesAreNotDuplicate = (t: TranslationsFunc) => (guests) => {
  const propertiesToTestForDuplicates = ['firstName', 'lastName', 'title', 'gender'];
  const nameIsDuplicated = checkArrayForDuplicates(guests, propertiesToTestForDuplicates);

  return nameIsDuplicated ? t('error.duplicateName') : undefined;
};

export const required = (code: string, label: string) => (value: any) => {
  if (value) {
    return undefined;
  }
  return [
    {
      code,
      label,
    },
  ];
};
